<template>
  <div class=""></div>
</template>

<script>
export default {
  components: {},
  mixins: [],
  props: {},
  data() {
    return {}
  },
  methods: {},
}
</script>

<style scoped></style>
